import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTable = (año) => [
    {label:`TENDENCIA ${año}-CIERRE`, colIni:0, colFin:7},
    {label:'', colIni:8, colFin:10},
    {label:`PROPUESTA DE OBJETIVOS ${año+1} (Δ s/TENDENCIA ${año}-CIERRE)`, colIni:11, colFin:31}
]

export const columnsTable = (año) => [
    {
        field: 'conT_TEND',
        name: 'CONT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.conT_TEND,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_TEND',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_TEND,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_TEND',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_TEND,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_TEND',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_TEND,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_TEND',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_TEND)>100 ? mayorCien(data.margen_TEND) : formaterNumberCell(data.margen_TEND,1)}</span>),
        width:'100px'
    },
    {
        field: 'bdI_TEND',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_TEND,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'carT_TEND',
        name: 'CART',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.carT_TEND,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        name: 'Centro',
        'data-test-subj': 'centro',
        sortable: true,
        render: (data) =>(
            <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
        ),
        width:'400px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'cont',
        name: 'CONT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cont,0)}</span>),
        width:'110px'
    },
    {
        field: 'conT_TEND_OBJ',
        name: `Δ s/${año} CONT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.conT_TEND_OBJ)>100 ? mayorCien(data.conT_TEND_OBJ) : formaterNumberCell(data.conT_TEND_OBJ,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_TEND_OBJ',
        name: `Δ s/${año} FACT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.facT_TEND_OBJ)>100 ? mayorCien(data.facT_TEND_OBJ) : formaterNumberCell(data.facT_TEND_OBJ,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_TEND_OBJ',
        name: `Δ s/${año} PROD (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.proD_TEND_OBJ)>100 ? mayorCien(data.proD_TEND_OBJ) : formaterNumberCell(data.proD_TEND_OBJ,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_TEND_OBJ',
        name: `Δ s/${año} APOR (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.apoR_TEND_OBJ)>100 ? mayorCien(data.apoR_TEND_OBJ) : formaterNumberCell(data.apoR_TEND_OBJ,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.margen,1)}</span>),
        width:'100px'
    },
    // {
    //     field: 'margen_DIF',
    //     name: `Δ s/${año-1} %MARGEN (DIF.)`,
    //     sortable: false,
    //     dataType: 'number',
    //     render: (data) => (<span>{Math.abs(data.margen_DIF)>100 ? '>100' : formaterNumberCell(data.margen_DIF,1)}</span>),
    //     width:'100px'
    // },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_TEND_OBJ',
        name: `Δ s/${año} BDI (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.bdI_TEND_OBJ)>100 ? mayorCien(data.bdI_TEND_OBJ) : formaterNumberCell(data.bdI_TEND_OBJ,1)}</span>),
        width:'100px'
    },
    {
        field: 'tipO_MEDIO_IMP',
        name: 'Tipo Medio Impositivo',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.tipO_MEDIO_IMP)>100 ? mayorCien(data.tipO_MEDIO_IMP) : formaterNumberCell(data.tipO_MEDIO_IMP,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },

    {
        field: 'cart',
        name: 'CART',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cart,0)}</span>),
        width:'110px'
    },
    {
        field: 'carT_TEND_OBJ',
        name: `Δ s/${año} CART (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.carT_TEND_OBJ)>100 ? mayorCien(data.carT_TEND_OBJ) : formaterNumberCell(data.carT_TEND_OBJ,1)}</span>),
        width:'100px'
    }
  ];